import urljoin from 'url-join';
import axios from 'axios';

var requestHeaders = {
  'Content-Type': 'application/json'
};
var transformRequest = function transformRequest(data) {
  if (data === void 0) {
    data = {};
  }

  if (typeof data === 'string') return data;
  return JSON.stringify(data);
};

var responseInterceptor = function responseInterceptor(response) {
  return response;
};
var exceptionInterceptor = function exceptionInterceptor(error) {
  var response = error.response;
  var tip = '故障';
  var feedbackMethod = console.warn;

  if (!response) {
    tip = '没响应';
  } else {
    var status = response ? response.status : 0;

    if (status === 404) {
      tip = '不在了';
    } else if (status === 500 && response.data.message) {
      tip = "[" + status + "] " + response.data.message;
      feedbackMethod = console.error;
    } else {
      tip = "[" + status + "] \u4E0D\u7ED9\u529B";
    }
  }

  feedbackMethod('抱歉～ ' + tip);
  console.log(typeof error.response === 'undefined' ? '' : error.response.data);
  return Promise.reject(error);
};

var SERVER_NAME = 'ec';
var HOST = process.env.HOST || 'http://api.scope.com';
var baseURL = /*#__PURE__*/urljoin(HOST, SERVER_NAME);
var ins = /*#__PURE__*/axios.create({
  baseURL: baseURL,
  headers: requestHeaders,
  transformRequest: [transformRequest],
  timeout: 10000
});
ins.interceptors.response.use(responseInterceptor, exceptionInterceptor);

var ChargeConfigApi;

(function (ChargeConfigApi) {
  var _basePath = '/chargeConfig';
  var _host = HOST;

  function setHost(host) {
    _host = host;
  }

  ChargeConfigApi.setHost = setHost;

  function applyHeaders(headers) {
    for (var k in headers) {
      ins.defaults.headers.common[k] = headers[k];
    }
  }

  ChargeConfigApi.applyHeaders = applyHeaders;

  function g() {
    for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
      parts[_key] = arguments[_key];
    }

    return urljoin.apply(void 0, [_host, SERVER_NAME, _basePath].concat(parts));
  }

  function getSingleHouseChargeConfig(request) {
    return ins.post(g("/singleHouseSpace"), request);
  }

  ChargeConfigApi.getSingleHouseChargeConfig = getSingleHouseChargeConfig;
})(ChargeConfigApi || (ChargeConfigApi = {}));

export { ChargeConfigApi };
//# sourceMappingURL=services-ec.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-ec/dist/services-ec.esm.js
// module id = K58P
// module chunks = 256